var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.1805L12.748 16.864C13.4182 17.2873 14.2449 16.6582 14.0671 15.861L12.9395 10.8027L16.6933 7.39886C17.2849 6.86288 16.9686 5.84549 16.1889 5.77659L11.2476 5.33814L9.31472 0.564394C9.00952 -0.188131 7.99048 -0.188131 7.68529 0.564394L5.75237 5.33814L0.811073 5.77659C0.0314082 5.84549 -0.284903 6.86288 0.306684 7.39886L4.06053 10.8027L2.93292 15.861C2.7551 16.6582 3.58179 17.2873 4.25203 16.864L8.5 14.1805Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/FeedbackIcon.4d3f96264989a3cbcf8b4f95adb9e10d.svg";
export { ForwardRef as ReactComponent };